import React, { useState, useCallback, useEffect } from 'react';
import { Select, Tooltip } from 'antd';
import {
  getJoySpaceDelPermission,
  getJoySpaceReadAllPermission,
  getJoySpaceReadNothingPermission,
  getJoySpaceReadOnlyPermission,
  getJoySpaceReadWritePermission,
  JoyspacePermissionType,
} from '../config/permissions.config';
import {
  getFolderMenus,
  getFolderAllMenus,
  getPageMenusAll,
  getPageMenus,
} from './config';
import styles from './index.module.less';
import { FileType } from '../types';
const { Option } = Select;
interface IProps {
  type?: FileType; // 判断是文件还是文件夹
  permissionType: JoyspacePermissionType;
  onClick?: Function;
  onChange?: Function;
  onlyText?: Boolean; // 是否为全部权限设置
  isDisableAll?: Boolean; // 权限选择是否显示可管理
  isCheckAll?: Boolean; // 是否为全部权限设置
  propsValue?: string;
  isOnlyText?: Boolean;
  isShowDelMenu?: Boolean;
  ownerNum?: number;
  isLoginUser?: Boolean;
  hasTip?: boolean;
  isKnowledge?: boolean;
}

const PermissionSelect = (props: IProps) => {
  const {
    type = FileType.Page, // 判断是文件还是文件夹
    permissionType = getJoySpaceReadOnlyPermission(),
    isDisableAll = false,
    onClick,
    onChange,
    propsValue,
    isCheckAll = false,
    isOnlyText,
    isShowDelMenu = false,
    ownerNum = 0,
    isLoginUser = false,
    hasTip = true,
    isKnowledge = false,
  } = props;
  const [value, setValue] = useState(propsValue);
  const [onlyText, setOnlyText] = useState(isOnlyText ?? false);
  const [menus, setMenus] = useState([]);
  const getDelMenu = useCallback(() => {
    if (isShowDelMenu) {
      return {
        title: '删除',
        tip:
          type === FileType.Page ? '删除文档权限' : '删除文档权限和文件夹权限',
        permissions: getJoySpaceDelPermission(),
      };
    }
    return null;
  }, [isShowDelMenu, type]);
  useEffect(() => {
    let useMenus: any[] = [];

    if (isCheckAll && type === FileType.Folder) {
      useMenus = getFolderAllMenus();
    }
    if (!isCheckAll && type === FileType.Folder) {
      useMenus = getFolderMenus();
    }
    if (isCheckAll && type === FileType.Page) {
      useMenus = getPageMenusAll();
    }
    if (!isCheckAll && type === FileType.Page) {
      useMenus = getPageMenus();
    }
    useMenus = useMenus.filter(item => {
      if (
        item.permissions < permissionType ||
        (isLoginUser &&
          (value as any) === getJoySpaceReadAllPermission() &&
          (item.permissions === getJoySpaceReadOnlyPermission() ||
            item.permissions === getJoySpaceReadWritePermission()))
      ) {
        return false;
      }

      return true;
    });
    // 增加移除按钮
    if (!isCheckAll && isShowDelMenu && permissionType <= Number(value)) {
      useMenus.push(getDelMenu());
    }
    // @ts-ignore
    setMenus(useMenus);
  }, [
    isCheckAll,
    type,
    permissionType,
    getDelMenu,
    value,
    isShowDelMenu,
    isLoginUser,
    isKnowledge,
  ]);
  const getPermissionText = useCallback(
    permission => {
      for (const item of menus) {
        if (permission === (item as any).permissions) {
          return (item as any)?.title;
        }
      }
      if (permission === getJoySpaceReadWritePermission()) {
        return '可编辑';
      }
      if (permission === getJoySpaceReadAllPermission()) {
        return '可管理';
      }
      return;
    },
    [menus]
  );
  const getTextNode = useCallback(() => {
    const permission = propsValue ?? permissionType;
    if (isKnowledge) {
      // if (ownerNum === 1 && permission === getJoySpaceReadAllPermission()) {
      //   return (
      //     <Tooltip
      //       placement="top"
      //       title="该用户是唯一的管理员，如想删除，请添加另一位管理员。"
      //       overlayClassName={styles['permission-text-tooltip']}
      //     >
      //       <span style={{ opacity: 0.5 }}>
      //         {getPermissionText(permission)}
      //       </span>
      //     </Tooltip>
      //   );
      // }
      return (
        <span style={{ opacity: 0.5 }}>{getPermissionText(permission)}</span>
      );
    }
    return getPermissionText(permission);
  }, [isKnowledge, ownerNum, propsValue, permissionType]);
  useEffect(() => {
    isOnlyText !== undefined && setOnlyText(isOnlyText);
  }, [isOnlyText]);
  // useEffect(() => {
  //     if (!isLoginUser && permissionType === getJoySpaceReadOnlyPermission()) {
  //         setOnlyText(true);
  //     }
  // }, [permissionType, isLoginUser]);
  useEffect(() => {
    setValue(propsValue);
  }, [propsValue]);

  const onChangeHandle = useCallback(
    (values: any) => {
      onChange?.(values);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [onChange, setValue]
  );
  if (onlyText && isCheckAll) {
    return (
      <Select
        size="small"
        value={value}
        defaultValue="批量设置权限"
        dropdownMatchSelectWidth={false}
        // onChange={(values) => {
        //     onChangeHandle?.(values);
        // }}
        onSelect={value => {
          // onChangeHandle?.(value);
        }}
        className={styles['joyspace-permission-select']}
        dropdownClassName={styles['joyspace-permission-select-dropdown']}
      >
        {(menus as any[]).map((_item, _index) => {
          return (
            <Option
              key={_index}
              value={_item.permissions}
              className={styles['joyspace-permission-select-option']}
            >
              {_item.title}
              <p className={styles['permission-select-tip']}>
                {isKnowledge
                  ? _item?.tip?.replace?.('文件夹', '知识库')
                  : _item.tip}
              </p>
            </Option>
          );
        })}
      </Select>
    );
  }
  if (
    onlyText ||
    (!isKnowledge &&
      ownerNum === 1 &&
      (value as any) === getJoySpaceReadAllPermission()) || // 管理协作者，只有一个可管理不允许更改
    permissionType === getJoySpaceReadNothingPermission()
  ) {
    return (
      <span className={styles['joyspace-select-only-text']}>
        {getTextNode()}
      </span>
    );
  }
  if (typeof propsValue !== 'undefined') {
    return (
      <Select
        size="small"
        value={value}
        defaultValue="批量设置权限"
        dropdownMatchSelectWidth={false}
        // onChange={(values) => {
        //     onChangeHandle?.(values);
        // }}
        onSelect={value => {
          onChangeHandle?.(value);
        }}
        className={styles['joyspace-permission-select']}
        dropdownClassName={styles['joyspace-permission-select-dropdown']}
      >
        {(menus as any[]).map((_item, _index) => {
          if (
            isDisableAll &&
            !isCheckAll &&
            _item.permissions === getJoySpaceReadAllPermission()
          ) {
            return null;
          }
          return (
            <Option
              key={_index}
              value={_item.permissions}
              disabled={
                isDisableAll &&
                _item.permissions === getJoySpaceReadAllPermission()
                  ? true
                  : false
              }
              className={`${styles['joyspace-permission-select-option']} ${
                !hasTip ? styles['select-option-no-tip'] : ''
              }`}
            >
              {_item.title}
              {hasTip && (
                <p className={styles['permission-select-tip']}>
                  {isKnowledge
                    ? _item?.tip?.replace?.('文件夹', '知识库')
                    : _item.tip}
                </p>
              )}
            </Option>
          );
        })}
      </Select>
    );
  }
  return (
    <Select
      size="small"
      defaultValue="批量设置权限"
      dropdownMatchSelectWidth={false}
      onSelect={value => {
        onChangeHandle?.(value);
      }}
      className={styles['joyspace-permission-select']}
      dropdownClassName={styles['joyspace-permission-select-dropdown']}
    >
      {(menus as any[]).map((_item, _index) => {
        if (
          isDisableAll &&
          !isCheckAll &&
          _item.permissions === getJoySpaceReadAllPermission()
        ) {
          return null;
        }
        return (
          <Option
            key={_index}
            value={_item.permissions}
            disabled={
              isDisableAll &&
              _item.permissions === getJoySpaceReadAllPermission()
                ? true
                : false
            }
            className={styles['joyspace-permission-select-option']}
          >
            {_item.title}
            <p className={styles['permission-select-tip']}>
              {isKnowledge
                ? _item?.tip?.replace?.('文件夹', '知识库')
                : _item.tip}
            </p>
          </Option>
        );
      })}
    </Select>
  );
};
export default PermissionSelect;
